const __WEBPACK_NAMESPACE_OBJECT__ = require("@toruslabs/fetch-node-details");